// extracted by mini-css-extract-plugin
export default {"profession-report-container":"Profession_profession-report-container__ZtTW8"};